import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "description-box" }
const _hoisted_2 = { class: "description" }
const _hoisted_3 = { class: "container container--description" }
const _hoisted_4 = { class: "description__text-box" }
const _hoisted_5 = { class: "description__name" }
const _hoisted_6 = {
  key: 0,
  class: "description__subtitle"
}
const _hoisted_7 = { class: "description__text description__text--show" }
const _hoisted_8 = { class: "description__text-c" }
const _hoisted_9 = { class: "description__img-box" }
const _hoisted_10 = ["src"]

import { computed } from 'vue'

import { ListDescriptionView } from '@/models/docs.list.description'


export default /*@__PURE__*/_defineComponent({
  __name: 'ListingPageDescription',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const toggleFullTextLabel = computed(() => {
  return props.view.showFullText ? 'Show less' : 'Show more'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(__props.view.title), 1),
          (__props.view.author)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.view.author), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, [
              _createTextVNode(_toDisplayString(__props.view.displayedText) + " ", 1),
              (__props.view.hasLongText)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "description__toggle-full-text",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.view.toggleShowFullText && __props.view.toggleShowFullText(...args)))
                  }, _toDisplayString(toggleFullTextLabel.value), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("img", {
            class: "description__img",
            src: __props.view.imageUrl,
            alt: ""
          }, null, 8, _hoisted_10)
        ])
      ]),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})